import ChampionshipResponseInterface from '@/webcomponents/f1-season/store/interface/championship';
import DriverResponseInterface from '@/webcomponents/f1-season/store/interface/driver';
import TeamResponseInterface from '@/webcomponents/f1-season/store/interface/team';
import { sortByPointOrPosition } from '../../helpers/sort';

export default class Championship {
  '@id' = '';
  '@type' = '';
  id = 0;
  saison = 0;
  channel = '';
  racesTotal = '';
  racesDone = '';
  drivers: Array<DriverResponseInterface> = [];
  teams: Array<TeamResponseInterface> = [];
  seasonYear = '';

  constructor (apiData: ChampionshipResponseInterface) {
    Object.keys(apiData).forEach((apiDataKey) => {
      this[apiDataKey] = apiData[apiDataKey];
    });
    this.drivers.sort(sortByPointOrPosition);
    this.teams.sort(sortByPointOrPosition);
  }

  getYear () {
    return typeof this.saison !== 'undefined' ? Number(this.saison) : null;
  }
}
